.bundleCard {
  display: flex;
  min-width: 98px;
  width: 98px;
  height: 98px;
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  position: relative;
  border: 1px solid var(--colors-grays-light);
  color: var(--colors-grays-mid);

  &:first-of-type {
    margin-left: 16px;
  }

  &:last-of-type {
    margin-right: 16px;
  }
}

.bundleCardImage {
  height: 100%;
  width: 100%;
}

.activeCard {
  border: 2px solid var(--colors-grays-dark);
  color: var(--colors-grays-dark);
}

.dealUnlocked {
  border: 2px solid var(--colors-info-main);
  color: var(--colors-info-main);
}

.trashBundle {
  border: 1px solid var(--colors-grays-light);
  border-radius: 50%;
  background-color: var(--colors-grays-white);
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(25%, -25%);
  z-index: 1;
  cursor: pointer;
}

@media all and (--reefer-media-tablet-min) {
  .bundleCard {
    min-width: 120px;
    width: 120px;
    height: 120px;
  }
}
